import cn from "classnames"

import styles from "./Descriptions.module.scss"

import type { LabelDescriptionsComponent } from "."

export const LabelDescriptions: LabelDescriptionsComponent = ({
  children,
  textTransform
}) => (
  <span
    className={cn(styles.label, {
      [styles.labelTextTransformUnset]: textTransform === "unset"
    })}
  >
    {children}
  </span>
)
